import Vue from "vue";
import PERSONAL_CONFIG from "@/configs/personal_config.json";
import { clone } from "lodash";
import store from "@/store";
const TAX_STEPS = PERSONAL_CONFIG.TAX_STEPS;
const DEDUCTS_MAX_CAP = PERSONAL_CONFIG.DEDUCTS_MAX_CAP;

export function calculatePersonalTaxInfo({ incomes, deducts }) {
  let totalIncome = 0;
  let totalExpense = 0;
  let totalDeduct = 0;
  let incomeBeforeTax = 0;
  store.dispatch("taxInfo/addTaxCharter", false);
  let totalDeducts = {
    personal: DEDUCTS_MAX_CAP.PERSONAL,
    spouse: 0,
    pregnancy: 0,
    children: 0,
    parents: 0,
    handicaps: 0,
    houseInterest: 0,
    firstHouse: 0,
    lifeInsurance: 0,
    pensionInsurance: 0,
    healthInsurance: 0,
    parentHealthInsurance: 0,
    sso: 0,
    pvd: 0,
    ssf: 0,
    rmf: 0,
    partyDonation: 0,
  };

  const isCharter = incomes.onlineSelling.isCharter;
  if (incomes.onlineSelling) {
    totalIncome = totalIncome + incomes.onlineSelling.income;
    if (isCharter) {
      totalExpense = totalExpense + totalIncome * 0.6;
    } else {
      totalExpense = totalExpense + incomes.onlineSelling.expense;
    }
  }
  if (incomes.salary) {
    totalIncome = totalIncome + incomes.salary.income;
    const salaryExpense = Math.min(incomes.salary.income * 0.5, 100000);
    totalExpense = totalExpense + salaryExpense;
  }
  if (deducts.spouse) {
    totalDeducts.spouse = deducts.spouse;
  }
  if (deducts.pregnancy) {
    totalDeducts.pregnancy = deducts.pregnancy;
  }
  if (deducts.children) {
    totalDeducts.children = deducts.children;
  }
  if (deducts.parents) {
    totalDeducts.parents = deducts.parents;
  }
  if (deducts.handicaps) {
    totalDeducts.handicaps = deducts.handicaps;
  }
  if (deducts.houseInterest) {
    totalDeducts.houseInterest = Math.min(
      deducts.houseInterest,
      DEDUCTS_MAX_CAP.HOUSE_INTEREST
    );
  }
  if (deducts.firstHouse) {
    totalDeducts.firstHouse = deducts.firstHouse;
  }
  if (deducts.lifeInsurance) {
    totalDeducts.lifeInsurance = Math.min(
      deducts.lifeInsurance,
      DEDUCTS_MAX_CAP.LIFE_INSURANCE
    );
  }
  if (deducts.pensionInsurance) {
    const lifeInsuranceRemainCap =
      DEDUCTS_MAX_CAP.LIFE_INSURANCE - totalDeducts.lifeInsurance;
    totalDeducts.pensionInsurance = Math.min(
      deducts.pensionInsurance,
      DEDUCTS_MAX_CAP.PENSION_INSURANCE + lifeInsuranceRemainCap
    );
  }
  if (deducts.healthInsurance) {
    totalDeducts.healthInsurance = Math.min(
      deducts.healthInsurance,
      DEDUCTS_MAX_CAP.HEALTH_INSURANCE
    );
  }
  if (deducts.parentHealthInsurance) {
    totalDeducts.parentHealthInsurance = Math.min(
      deducts.parentHealthInsurance,
      DEDUCTS_MAX_CAP.PARENT_HEALTH_INSURANCE
    );
  }
  if (deducts.sso) {
    totalDeducts.sso = Math.min(deducts.sso, DEDUCTS_MAX_CAP.SSO);
  }

  if (deducts.pvd) {
    totalDeducts.pvd = deducts.pvd;
    totalDeducts.pvd = Math.min(totalDeducts.pvd, DEDUCTS_MAX_CAP.PVD);
  }
  if (deducts.ssf) {
    totalDeducts.ssf = deducts.ssf;
    totalDeducts.ssf = Math.min(totalDeducts.ssf, totalIncome * 0.3);
    totalDeducts.ssf = Math.min(totalDeducts.ssf, DEDUCTS_MAX_CAP.SSF);
    totalDeducts.ssf = Math.min(
      totalDeducts.ssf,
      DEDUCTS_MAX_CAP.PVD - totalDeducts.pvd
    );
  }
  if (deducts.rmf) {
    totalDeducts.rmf = deducts.rmf;
    totalDeducts.rmf = Math.min(totalDeducts.rmf, totalIncome * 0.3);
    totalDeducts.rmf = Math.min(
      totalDeducts.rmf,
      DEDUCTS_MAX_CAP.PVD - totalDeducts.pvd
    );
  }

  if (deducts.partyDonation) {
    totalDeducts.partyDonation = Math.min(
      deducts.partyDonation,
      DEDUCTS_MAX_CAP.PARTY_DONATION
    );
  }

  totalDeduct = Vue.lodash.sum(Vue.lodash.values(totalDeducts));
  incomeBeforeTax = Math.max(0, totalIncome - totalExpense - totalDeduct);

  if (deducts.specialDonation) {
    totalDeducts.specialDonation = deducts.specialDonation * 2;
    totalDeducts.specialDonation = Math.min(
      totalDeducts.specialDonation,
      incomeBeforeTax * 0.1
    );
    incomeBeforeTax = incomeBeforeTax - totalDeducts.specialDonation;
  }
  if (deducts.generalDonation) {
    totalDeducts.generalDonation = deducts.generalDonation;
    totalDeducts.generalDonation = Math.min(
      totalDeducts.generalDonation,
      incomeBeforeTax * 0.1
    );
    incomeBeforeTax = incomeBeforeTax - totalDeducts.generalDonation;
  }

  totalDeduct = Vue.lodash.sum(Vue.lodash.values(totalDeducts));
  incomeBeforeTax = Math.max(0, totalIncome - totalExpense - totalDeduct);

  let tax = 0;
  let maxTaxRate = 0;

  const taxSteps = clone(TAX_STEPS);

  taxSteps.reverse().forEach(({ rate, minIncome }) => {
    const overIncome = Math.max(0, incomeBeforeTax - minIncome);
    if (overIncome > 0) {
      maxTaxRate = Math.max(rate, maxTaxRate);
      incomeBeforeTax = incomeBeforeTax - overIncome;
    }

    tax = tax + overIncome * rate;
  });

  if (incomes.onlineSelling) {
    const charterTax = incomes.onlineSelling.income * 0.005;
    if (charterTax > 5000 && charterTax > tax) {
      totalDeducts = {
        personal: 0,
        spouse: 0,
        pregnancy: 0,
        children: 0,
        parents: 0,
        handicaps: 0,
        houseInterest: 0,
        firstHouse: 0,
        lifeInsurance: 0,
        pensionInsurance: 0,
        healthInsurance: 0,
        parentHealthInsurance: 0,
        sso: 0,
        pvd: 0,
        ssf: 0,
        rmf: 0,
        partyDonation: 0,
      };
      totalIncome = incomes.onlineSelling.income;
      totalExpense = 0;
      tax = charterTax;
      maxTaxRate = 0.005;
      store.dispatch("taxInfo/addTaxCharter", true);
    }
  }

  return {
    totalDeducts,
    totalIncome,
    totalExpense,
    tax,
    maxTaxRate,
  };
}
